import script from "./DeviceCardSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./DeviceCardSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./DeviceCardSkeleton.vue?vue&type=style&index=0&id=3ab2be10&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3ab2be10"]])

export default __exports__